export const errorMessages = {
    CONTACT_ERROR : "Error loading contact information. Please try again or contact an administrator.",
    GENERATE_ERROR : "Error generating a new code. Please try again or contact an administrator.",
    VALIDATE_ERROR : "Error validating the entered code. Please try again or contact an administrator.",
    TOO_MANY_ERROR : "Your account has too many active codes. Please wait until the timer counter completes to send another code.",
    LOCKED_ERROR : "Too many validation requests. Account has been locked for 30 minutes.",
    AUTH_ERROR : "Error authenticating request. Return to home screen.",
    DEFAULT_ERROR : "There was a problem with your request.",
}